import type { AxiosResponse } from "axios";

import { validateValues } from "../../utils";

import api from "../../../../../api";
import type { CommandFormValues } from "../../types";
import { generateInviteLinkSchema } from "./types";
import type { IUser } from "../../../../../types";

export const handleGenerateInviteLink = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  validateValues(values, generateInviteLinkSchema);

  const response = await api.kontax.generateInviteLink(user.id);

  // Automatically copy the invite link to clipboard
  if (response.data?.inviteLink) {
    await navigator.clipboard.writeText(response.data.inviteLink);
  }

  return response;
};
